import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Home from './components/Home/Home'
import Register from './components/Register/Register'
import Login from './components/Login/Login'
import Admin from './components/Admin/Admin'
import Book from './components/Book/Book'
import UserProfile from './components/UserProfile/UserProfile'
import Appointment from './components/Appointment/Appointment'
import { ProtectedRoute } from './protected.route'
import {  AdminRoute } from './admin.route'
import { AuthProvider } from './auth/AuthContext'

import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <Switch>

            <Route path='/' exact component={Home} />
            <Route path='/register' component={Register} />
            <Route path='/login' component={Login} />
            <Route path='/book' component={Book} />
            <AdminRoute component={Admin} path='/admin' />
            <ProtectedRoute component={UserProfile} path='/profile' />
            <Route path='/appointment' component={() => {
                window.location.href = 'https://nail-labs.square.site/s/appointments';
                return null;
            }}/>
            <Route path='/shop' component={() => {
                window.location.href = 'https://nail-labs.square.site/s/shop';
                return null;
            }}/>
            <Route path='/cart' component={() => {
                window.location.href = 'https://nail-labs.square.site/s/cart';
                return null;
            }}/>
            <Route path='*' component={() => '404 PAGE NOT FOUND'} />

          </Switch>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
